import { axiosPost, axiosGet } from "../../../react_axios/Axios"
import {
    platform, headers, verifyPartnerCodeUrl, VERIFY_PARTNER_CODE, sendPartnerRegistrationFormUrl, getPartnerStaticDataUrl, GET_PARTNER_STATIC_DATA, PARTNER_REGISTRATION_FORM, getPartnerApplicationDetailsUrl, PARTNER_APPLICATION_DETAILS, updatePartnerApplicationFormUrl, UPDATE_PARTER_APPLICATION, partnerApplicationDeleteDocUrl, PARTNER_DELETE_DOC
} from "../../../utils/constants"



export const getPartnerApplicationDetails_action = () => async (dispatch) => {
    try {
        const mapdata = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
        }

        const res = await axiosGet(getPartnerApplicationDetailsUrl, mapdata, headers);
        dispatch({
            type: PARTNER_APPLICATION_DETAILS,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const partnerDeleteDoc_action = () => async (dispatch) => {
    try {
        const mapdata = {
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
        }

        const res = await axiosGet(partnerApplicationDeleteDocUrl, mapdata, headers);
        dispatch({
            type: PARTNER_DELETE_DOC,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updatePartnerApplication_action = (
    PartnerTypeID,
    Title_PersonIncharge,
    PersonIncharge,
    LastNamePersonIncharge,
    Designation,
    CompanyName,
    FasciaName,
    Address1,
    Address2,
    Pin,
    City,
    State,
    CountryID,
    MobileNo,
    AlternateMobileNo,
    Telephone,
    PrimaryEmail,
    SecondaryEmail,
    Website,
    logo,
    isAgree,
    partnerDeliverableList,
    partnerBearerList,
    partnerRegionList,
    partnerTotalCirculationList,
    partnerOverseasCirculationList,
    partnerOnlinePresenceList,
    chapterList,
    logoImg,
    logoImgType, exhno, totalCirculationNo, isAgreeConsent, AuthorizedPersonName,
    DesignationAuthorizedPerson,
    ExhibitorCompanyName,
    EmailAuthorizedPerson,
    MobileAuthorizedPerson,) => async (dispatch) => {
        try {
            const mapdata = {
                ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
                ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
                PartnerTypeID: PartnerTypeID,
                Title_PersonIncharge: Title_PersonIncharge,
                PersonIncharge: PersonIncharge,
                LastNamePersonIncharge: LastNamePersonIncharge,
                Designation: Designation,
                CompanyName: CompanyName,
                FasciaName: FasciaName,
                Address1: Address1,
                Address2: Address2,
                Pin: Pin,
                City: City,
                State: State,
                CountryID: CountryID,
                MobileNo: MobileNo,
                AlternateMobileNo: AlternateMobileNo,
                Telephone: Telephone,
                PrimaryEmail: PrimaryEmail,
                SecondaryEmail: SecondaryEmail,
                Website: Website,
                logo: logo,
                isAgree: isAgree,
                partnerDeliverableList: partnerDeliverableList,
                partnerBearerList: partnerBearerList,
                partnerRegionList: partnerRegionList,
                partnerTotalCirculationList: partnerTotalCirculationList,
                partnerOverseasCirculationList: partnerOverseasCirculationList,
                partnerOnlinePresenceList: partnerOnlinePresenceList,
                chapterList: chapterList,
                logoImg: logoImg,
                logoImgType: logoImgType,
                exhno: exhno,
                TotalCirculationNo: totalCirculationNo,
                isAgreeConsent: isAgreeConsent,
                ExhUndertakingPersonName: AuthorizedPersonName,
                ExhUndertakingDesignation: DesignationAuthorizedPerson,
                ExhUndertakingCompanyName: ExhibitorCompanyName,
                ExhUndertakingEmail: EmailAuthorizedPerson,
                ExhUndertakingMobileNo: MobileAuthorizedPerson,
            }

            const res = await axiosPost(updatePartnerApplicationFormUrl, mapdata, headers);
            dispatch({
                type: UPDATE_PARTER_APPLICATION,
                payload: res,
            });

            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };